import * as React from "react";
import { forwardRef } from "react";
const SvgNbIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Ebene_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 24 24", style: {
  enableBackground: "new 0 0 24 24"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { className: "st0", d: "M20,20H4c-1.7,0-3-1.3-3-3V7c0-1.7,1.3-3,3-3h16c1.7,0,3,1.3,3,3v10C23,18.7,21.7,20,20,20z M4,6 C3.4,6,3,6.4,3,7v10c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V7c0-0.6-0.4-1-1-1H4z" }), /* @__PURE__ */ React.createElement("rect", { x: 5, y: 8, width: 2, height: 3 }), /* @__PURE__ */ React.createElement("rect", { x: 5, y: 12.8, width: 2, height: 3 }));
const ForwardRef = forwardRef(SvgNbIcon);
export { ForwardRef as ReactComponent };
